import React from 'react';
import {Route, Routes} from 'react-router-dom';
import NavLink from './../../../../common/nav_link'

export default class extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            routes: [
                {type: 'route', url: '', name: 'Rate Tables'},
                {type: 'route', url: 'upload', name: 'Upload Rate'}
            ],
            data: {data:[], metadata: []}
        }
    }
    componentDidMount() {
        this.loadFromServer();
    }
    loadFromServer() {
        const url = `/admin/products/mms/rates`;
        this.props.childProps.dataProvider.getList(url, {}).then(
            response =>
                this.setState({
                    loading: false,
                    data: response.data
                })
        );
    }
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>MMS Rate Tables</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="nav nav-tabs">
                            {this.state.routes.map(function(row, index) {
                                return (
                                    <NavLink
                                        key={ index }
                                        to={`/products/mmsrates/${ row.url }`}
                                        default={`/products/mmsrates`}
                                    >
                                        { row.name }
                                    </NavLink>
                                )
                            }, this)}
                        </ul>
                    </div>
                </div>
                <Routes>
                    {this.props.routes.map((route, i) => (
                        <Route 
                            key={i} 
                            path={route.path} 
                            element={<route.component routes={route.routes} childProps={this.props.childProps} parent={this.state.data}/>} 
                        />
                    ))}
                </Routes>
            </div>
        )
    }
};
